import React, { useState, useEffect } from "react";
import { Button, Icon, Image } from "semantic-ui-react";
import { ENV, buildStorageUrl } from "../../../../../../utils";
import "../TemplateManager.scss";

export const Sev02 = React.memo((props) => {
  const {
    index,
    slideId,
    onLetterByOrder,
    activeSession,
    handleChoiceSelection,
  } = props;
  const [question, setQuestion] = useState("");
  const [image, setImage] = useState("");
  const [choices, setChoices] = useState([]);
  const [selectedChoice, setSelectedChoice] = useState(null);

  /**
   * Synchronizes component state with the content of the currently selected slide in Sev02.js.
   *
   * This `useEffect` hook is executed whenever the `slideId` changes. It searches the `activeSession.slides`
   * array for a slide that matches the `slideId`. If such a slide is found and it contains content, the hook
   * updates the component's state with the slide's question, choices, and image.
   *
   * Specifically, it performs the following actions:
   * - Sets the `question` state with the slide's question, where newline characters (`\n`) are replaced with `<br />` HTML tags for proper web formatting.
   * - Sets the `choices` state with a shuffled array of the slide's choices to ensure the order is randomized.
   * - Sets the `image` state with the slide's image URL, allowing for the display of an associated image.
   *
   * This ensures that the component accurately represents the content of the current slide, allowing for
   * effective editing and previewing within an active session. The inclusion of an image along with the question
   * and randomized choices enhances the user experience by providing a more engaging and visually appealing interface.
   *
   * @dependency slideId - The ID of the current slide, changes to which trigger the hook.
   */
  useEffect(() => {
    const slide = activeSession.slides.find((slide) => slide._id === slideId);
    if (slide && slide.content) {
      setQuestion(slide.content.question.replace(/\n/g, "<br />"));
      setChoices([...slide.content.choices]);
      setImage(slide.content.image);
      setSelectedChoice(
        slide.selectedChoice !== undefined ? slide.selectedChoice : null
      );
    }
  }, [slideId]);

  const handleChoiceClick = (choiceIndex, answer) => {
    setSelectedChoice(choiceIndex);
    handleChoiceSelection(index, choiceIndex, answer);
  };

  return (
    <div className="column">
      <h3 className="show-slide__title">
        <Icon name="question" />
        Pregunta:
      </h3>

      <div className="show-slide__body">
        <p
          className="show-slide__text"
          dangerouslySetInnerHTML={{ __html: question }}
        />
        <Image bordered rounded fluid src={buildStorageUrl(image)} />
        <div>
          {choices.map((choice, choiceIndex) => (
            <div key={choiceIndex}>
              <Button
                className="show-slide__choice"
                content={`${onLetterByOrder(choiceIndex + 1)}.`}
                color={selectedChoice === choiceIndex ? "blue" : null}
                label={{
                  className: "show-slide__choice-label",
                  basic: true,
                  pointing: "left",
                  color: selectedChoice === choiceIndex ? "blue" : null,
                  content: `${choice.answer}`,
                }}
                labelPosition="right"
                onClick={() => handleChoiceClick(choiceIndex, choice.answer)}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});
